import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCardExpired = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 151,
	height: 137,
	viewBox: "0 0 151 137",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2331_1116)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				opacity: .1,
				d: "M76.6295 136.148C113.99 136.148 144.278 105.861 144.278 68.5001C144.278 31.1391 113.99 0.852051 76.6295 0.852051C39.2685 0.852051 8.98145 31.1391 8.98145 68.5001C8.98145 105.861 39.2685 136.148 76.6295 136.148Z",
				fill: "#367CFF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M152.045 48.4852L132.81 106.573C132.442 107.685 131.859 108.714 131.093 109.601C130.327 110.487 129.395 111.214 128.348 111.74C127.301 112.266 126.161 112.581 124.993 112.666C123.825 112.752 122.651 112.606 121.539 112.238L77.6109 97.6926L74.8745 85.9661L90.0565 76.7453L83.9903 60.1622L85.1977 58.5797L87.1552 56.0143L93.683 47.457L87.421 29.3697L95.3747 20.324L146.383 37.2141C147.495 37.5822 148.523 38.1658 149.41 38.9315C150.296 39.6972 151.023 40.63 151.549 41.6767C152.075 42.7233 152.389 43.8633 152.474 45.0315C152.56 46.1998 152.414 47.3733 152.045 48.4852Z",
				fill: "#262BA6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M126.735 97.4289C126.251 98.9166 125.353 100.236 124.148 101.233C122.942 102.229 121.477 102.862 119.925 103.058C118.373 103.253 116.797 103.003 115.382 102.336C113.966 101.67 112.77 100.614 111.932 99.2926C110.651 97.2321 110.187 94.677 111.001 92.219C111.39 91.0466 112.04 89.9772 112.9 89.0907C113.76 88.2041 114.81 87.5232 115.97 87.0988C117.431 86.5387 119.021 86.4057 120.554 86.7154C122.088 87.0252 123.501 87.7649 124.63 88.8481C125.759 89.9313 126.556 91.3133 126.929 92.8328C127.302 94.3522 127.234 95.9463 126.735 97.4289Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M108.982 98.3147C107.517 98.8733 105.924 99.0049 104.388 98.6943C102.851 98.3837 101.434 97.6436 100.301 96.56C99.1683 95.4764 98.366 94.0937 97.9875 92.5724C97.6089 91.0511 97.6696 89.4537 98.1625 87.9655C98.6553 86.4773 99.5602 85.1595 100.772 84.1649C101.984 83.1704 103.453 82.54 105.009 82.3468C106.564 82.1537 108.143 82.4058 109.561 83.0738C110.979 83.7419 112.179 84.7985 113.021 86.121C110.763 87.0099 109.255 88.9113 108.441 91.3697C107.627 93.8282 107.668 96.3525 108.982 98.3147Z",
				fill: "#8386E2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M88.4946 58.0646C88.3938 58.3692 88.1997 58.6343 87.9397 58.8222C87.6797 59.0101 87.367 59.1113 87.0462 59.1114C86.8837 59.1105 86.7223 59.0841 86.568 59.0331L85.1978 58.5798L87.1553 56.0144L87.5261 56.138C87.91 56.2651 88.2277 56.5395 88.4094 56.9008C88.591 57.2621 88.6216 57.6807 88.4946 58.0646Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M110.631 63.7881L94.9429 58.5935C94.1436 58.3288 93.281 58.7622 93.0164 59.5616C92.7517 60.3609 93.1851 61.2234 93.9844 61.4881L109.672 66.6827C110.471 66.9474 111.334 66.514 111.599 65.7146C111.863 64.9153 111.43 64.0528 110.631 63.7881Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M133.735 71.4387L118.047 66.2441C117.248 65.9795 116.385 66.4129 116.12 67.2122C115.856 68.0115 116.289 68.8741 117.088 69.1387L132.776 74.3333C133.575 74.598 134.438 74.1646 134.703 73.3653C134.967 72.566 134.534 71.7034 133.735 71.4387Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M60.8011 97.8408L68.5652 107.045L22.0097 114.158C20.8518 114.335 19.6704 114.282 18.5329 114.003C17.3955 113.723 16.3242 113.222 15.3803 112.529C14.4365 111.835 13.6385 110.962 13.0319 109.96C12.4253 108.958 12.022 107.847 11.8451 106.689L2.60325 46.1979C2.42639 45.0402 2.4793 43.8589 2.75895 42.7216C3.03861 41.5844 3.53955 40.5133 4.23315 39.5696C4.92675 38.6259 5.79944 37.8281 6.80139 37.2217C7.80334 36.6153 8.91492 36.2122 10.0727 36.0354L49.2556 30.0496L46.2781 41.7204L60.0713 54.9901L58.1406 65.5792L57.5616 68.7524L57.2051 70.7099L70.139 82.731L60.8011 97.8408Z",
				fill: "#262BA6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M27.9128 44.4458L16.3879 46.2067C14.3957 46.5111 13.0275 48.3728 13.3319 50.3649L14.3574 57.0771C14.6618 59.0692 16.5235 60.4375 18.5157 60.1331L30.0406 58.3722C32.0328 58.0678 33.401 56.2061 33.0966 54.2139L32.071 47.5018C31.7667 45.5096 29.905 44.1414 27.9128 44.4458Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M34.4689 69.1959L18.1331 71.6919C17.3007 71.819 16.7291 72.5969 16.8562 73.4292C16.9834 74.2616 17.7613 74.8332 18.5936 74.706L34.9294 72.2101C35.7618 72.0829 36.3334 71.3051 36.2063 70.4727C36.0791 69.6404 35.3012 69.0687 34.4689 69.1959Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M58.141 65.5791L57.562 68.7523L42.6521 71.0292C42.4542 71.0597 42.2523 71.0509 42.0579 71.0033C41.8634 70.9557 41.6803 70.8702 41.519 70.7518C41.3576 70.6333 41.2212 70.4842 41.1176 70.3129C41.014 70.1416 40.9451 69.9516 40.915 69.7537C40.9028 69.6767 40.8966 69.5989 40.8965 69.5209C40.8967 69.1569 41.0274 68.805 41.2648 68.5291C41.5022 68.2531 41.8306 68.0713 42.1905 68.0167L58.141 65.5791Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M52.1401 21.7191L44.5967 15.3128L51.2351 12.0862L52.1401 21.7191Z",
				fill: "#262BA6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M67.4839 23.6845L72.661 19.311L73.1134 24.1275L67.4839 23.6845Z",
				fill: "#262BA6"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2331_1116",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 150,
			height: 135.296,
			fill: "white",
			transform: "translate(0.5 0.852051)"
		})
	}) })]
});
export default SvgCardExpired;
